import { IFileInfo, IFileSystem } from 'fitbeat.react-native-components/HomeWorkouts';
import { FileSystem } from 'react-native-unimodules';

export class ExpoFileSystem implements IFileSystem {
  public cacheDirectory = FileSystem.cacheDirectory;

  public async getFreeDiskStorageMegaBytes(): Promise<number> {
    const bytes = await FileSystem.getFreeDiskStorageAsync();
    return bytes / 1048768;
  }

  public async getInfoAsync(filePath: string): Promise<IFileInfo> {
    const fileInfo = await FileSystem.getInfoAsync(filePath);
    return fileInfo;
  }

  public async downloadAsync(
    url: string,
    filePath: string,
    downloadProgressCallback?: (totalBytesWritten: number, totalBytesExpectedToWrite: number) => void) {
    const downloadResumable = FileSystem.createDownloadResumable(
      url,
      filePath,
      {},
      downloadProgressCallback,
    );

    return downloadResumable.downloadAsync(url, filePath);
  }

  public async moveAsync(from: string, to: string) {
    return FileSystem.moveAsync({
      from,
      to,
    });
  }

  public async makeDirectoryAsync(path: string) {
    return FileSystem.makeDirectoryAsync(path);
  }

  public async readDirectoryAsync(path: string): Promise<string[]> {
    return FileSystem.readDirectoryAsync(path);
  }

  public async deleteAsync(path: string) {
    return FileSystem.deleteAsync(path, {
      idempotent: true,
    });
  }
}
